
















































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { AdcontrolProfile, AgentModuleConfiguration } from "@/models";
import WindowEvent from "@/decorators/WindowEvent";
import AgentCompetitorsReportRecord from "@/models/interfaces/AgentCompetitors";
import EntryItem from "@/components/EntryItem.vue";
import CompetitorsFooter from "./CompetitorsFooter.vue";
import {
  ColumnDefinition,
  CompetitorReportColumnsService,
} from "@/services/AgentsModule/CompetitorReportColumnsService";
import MultiLevelObject from "@/interfaces/MultiLevelObject";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";

class Total {
  count!: number;
  seconds!: number;
  vod!: number;
  myCount!: number;
  mySeconds!: number;
  myVod!: number;
  vodDevices!: boolean;
  vodSmartTv!: boolean;
  myVodDevices!: boolean;
  myVodSmartTv!: boolean;
}

const SELECTED_ITEM_NAME = "agent-table-selected";

@Component({ components: { EntryItem, CompetitorsFooter, MultiLevelSelect } })
export default class AgentCompetitorsTable extends Vue {
  @Prop({ default: () => [] }) readonly value!: AgentCompetitorsReportRecord[];
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: false }) readonly showGrp!: boolean;
  @Prop({ default: null })
  readonly agentModuleConfiguration!: AgentModuleConfiguration | null;
  @Prop() readonly grpTargetId!: string | number;
  @Ref() inner!: HTMLDivElement;
  @Ref() table!: HTMLTableElement;
  @Getter("profile") readonly profile!: AdcontrolProfile;

  data: AgentCompetitorsReportRecord[] = [];

  selected: string[] = [];

  options: MultiLevelObject[] = [];

  agencyAgentsDynamicColumns: ColumnDefinition[] = [];
  agentCompanyAgentsDynamicColumns: ColumnDefinition[] = [];
  dynamicColumnsOffset = 0;

  get selectedAgentCompanyAgentsDynamicColumns() {
    return this.agentCompanyAgentsDynamicColumns.filter((column) =>
      this.selected.includes(column.fieldName)
    );
  }

  get selectedAgencyAgentsDynamicColumns() {
    return this.agencyAgentsDynamicColumns.filter((column) =>
      this.selected.includes(column.fieldName)
    );
  }

  position = {
    overflow: false,
    scrolledToRight: false,
    scrolledToLeft: true,
  };

  totals: Total = Object.assign(new Total(), {
    count: 0,
    seconds: 0,
    vod: 0,
    myCount: 0,
    mySeconds: 0,
    myVod: 0,
    vodDevices: false,
    vodSmartTv: false,
    myVodDevices: false,
    myVodSmartTv: false,
  });

  mounted() {
    this.initSelected();
    this.data = [...this.value];
    this.checkPosition();
    this.computeColumnTotals();
    this.computeDynamicsColumns(this.agentModuleConfiguration);
    this.initializeOptions();
  }

  get hideNonVod() {
    return this.profile?.mediaSourceKind === "msk_vod";
  }

  get showVod() {
    return (
      ["msk_vod", "msk_vod_and_tv"].indexOf(
        this.profile?.mediaSourceKind ?? ""
      ) > -1
    );
  }

  get mediaSourceKind() {
    return this.profile?.mediaSourceKind;
  }

  get selectedMultipleValue(): Array<string[]> {
    const selected: Array<string[]> = [];
    selected[0] = this.selected;

    return selected;
  }

  computeColumnTotals() {
    this.totals = this.data.reduce(
      (acc, element) => {
        acc.count += element.count;
        acc.seconds += element.seconds;
        acc.vod += element.vod_presence;
        acc.myCount += element.my_count;
        acc.mySeconds += element.my_seconds;
        acc.myVod += element.my_vod_presence;
        acc.vodDevices = acc.vodDevices || element.vod_other_devices;
        acc.vodSmartTv = acc.vodSmartTv || element.vod_smart_tv;
        acc.myVodDevices = acc.myVodDevices || element.my_vod_other_devices;
        acc.myVodSmartTv = acc.myVodSmartTv || element.my_vod_smart_tv;
        return acc;
      },
      Object.assign(new Total(), {
        count: 0,
        seconds: 0,
        vod: 0,
        myCount: 0,
        mySeconds: 0,
        myVod: 0,
        vodDevices: false,
        vodSmartTv: false,
        myVodDevices: false,
        myVodSmartTv: false,
      })
    );
  }

  protected initializeOptions() {
    const columns = [
      ...this.agentCompanyAgentsDynamicColumns,
      ...this.agencyAgentsDynamicColumns,
    ];
    if (columns.length > 0) {
      this.options = [
        {
          id: "agency_name",
          text: "AGENZIA",
          selected: true,
          locked: false,
        },
        {
          id: "agency_agent_name",
          text: "AGENTE AGENZIA",
          selected: true,
          locked: false,
        },
        ...columns.map((column) => {
          return {
            id: column.fieldName,
            text: column.fieldLabel,
            selected: true,
            locked: false,
          };
        }),
      ];
    }

    if (this.selected.length > 0) {
      this.options = this.options.map((option) => {
        option.selected = this.selected.indexOf(option.id) >= 0;
        return option;
      });
    } else {
      this.selected = this.options.map((option) => {
        return option.id;
      });
    }
  }

  sortState = {
    field: "",
    direction: "",
  };

  get totalColSpan(): number {
    let cols = this.showGrp ? 3 : 2;
    if (
      ["msk_vod", "msk_vod_and_tv"].indexOf(
        this.profile?.mediaSourceKind ?? ""
      ) > -1
    ) {
      cols += 2;
    }
    if (this.profile?.mediaSourceKind === "msk_vod") {
      cols -= 3;
    }
    return cols;
  }

  get selectedStorageName() {
    return `${this.profile.slug}-${SELECTED_ITEM_NAME}`;
  }

  get agencyColSpan(): number {
    let cols = this.showGrp ? 4 : 3;
    if (
      ["msk_vod", "msk_vod_and_tv"].indexOf(
        this.profile?.mediaSourceKind ?? ""
      ) > -1
    ) {
      cols += 2;
    }
    if (this.profile?.mediaSourceKind === "msk_vod") {
      cols -= 4;
    }
    return cols;
  }

  columnSelected(column: string) {
    return this.selected.indexOf(column) >= 0;
  }

  @Watch("agentModuleConfiguration")
  onAgentModuleConfigurationChanged() {
    this.computeDynamicsColumns(this.agentModuleConfiguration);
    this.initializeOptions();
  }

  @Watch("value")
  onValueChanged() {
    this.sortState = {
      field: "",
      direction: "",
    };
    this.data = [...this.value];
    this.checkPosition();
    this.computeColumnTotals();
  }

  initSelected() {
    const selected = localStorage.getItem(this.selectedStorageName);
    if (selected) {
      this.selected = JSON.parse(selected);
    }
  }

  @Watch("selected")
  onSelectedChanged() {
    localStorage.setItem(
      this.selectedStorageName,
      JSON.stringify(this.selected)
    );
    this.computeDynamicsColumns(this.agentModuleConfiguration);
  }

  @WindowEvent("resize")
  onResize() {
    if (!this.inner) {
      return;
    }
    this.checkPosition();
  }

  onSort(field: string) {
    if (field != this.sortState.field) {
      this.sortState.field = field;
      this.sortState.direction = "asc";
    } else {
      switch (this.sortState.direction) {
        case "asc":
          this.sortState.direction = "desc";
          break;
        case "desc":
          this.sortState.direction = "";
          break;
        case "":
          this.sortState.direction = "asc";
          break;
      }
    }
    this.sort();
  }

  computeDynamicsColumns(config: AgentModuleConfiguration | null) {
    const { agentCompanyAgentsRelated, agencyAgentsRelated } =
      CompetitorReportColumnsService.columnsFromConfig(config);
    this.agentCompanyAgentsDynamicColumns = [...agentCompanyAgentsRelated];
    this.agencyAgentsDynamicColumns = [...agencyAgentsRelated];
    this.dynamicColumnsOffset =
      this.selectedAgentCompanyAgentsDynamicColumns.length +
      this.selectedAgencyAgentsDynamicColumns.length;
    if (this.columnSelected("agency_name")) {
      this.dynamicColumnsOffset++;
    }
    if (this.columnSelected("agency_agent_name")) {
      this.dynamicColumnsOffset++;
    }
  }

  onRowClick(element: AgentCompetitorsReportRecord) {
    const dateEnd = this.$route.query.date;
    const weekly = this.$route.query.weeklyData == "true";
    const dateStart = weekly
      ? this.$moment(dateEnd).subtract(6, "days").format("YYYY-MM-DD")
      : dateEnd;
    this.$router.push({
      name: "InvestorSummary",
      params: {
        type: "products",
        id: `${element.product.id}`,
      },
      query: {
        from: dateStart,
        to: dateEnd,
      },
    });
  }

  protected cfr(a: string | number, b: string | number) {
    let parsedA = a;
    let parsedB = b;

    if (typeof a === "string" && typeof b === "string") {
      parsedA = a.replace(/\s/g, "");
      parsedB = b.replace(/\s/g, "");
    }

    if (parsedA < parsedB) {
      return -1;
    } else if (parsedA > parsedB) {
      return 1;
    } else {
      return 0;
    }
  }

  protected sort() {
    if (this.sortState.direction == "") {
      this.data = [...this.value];
    } else {
      this.data.sort((aElement, bElement) => {
        const a = this.sortState.direction == "asc" ? aElement : bElement;
        const b = this.sortState.direction == "asc" ? bElement : aElement;
        switch (this.sortState.field) {
          case "count":
            return this.cfr(a.count, b.count);
          case "seconds":
            return this.cfr(a.seconds, b.seconds);
          case "vod_presence":
            return this.cfr(a.vod_presence, b.vod_presence);
          case "my_count":
            return this.cfr(a.my_count, b.my_count);
          case "my_seconds":
            return this.cfr(a.my_seconds, b.my_seconds);
          case "my_vod_presence":
            return this.cfr(a.my_vod_presence, b.my_vod_presence);
          case "region":
            return this.cfr(a.company.region, b.company.region);
          case "agent_company_name":
            return this.cfr(
              a.agent_company_name ?? a.company.name,
              b.agent_company_name ?? b.company.name
            );
          case "agent_product_name":
            return this.cfr(
              a.agent_product_name ?? a.product.name,
              b.agent_product_name ?? b.product.name
            );
          case "sov":
            return this.cfr(a.sov, b.sov);
          case "grp":
            return this.cfr(
              Number.parseFloat(`${a.grp}`),
              Number.parseFloat(`${b.grp}`)
            );
          case "my_grp":
            return this.cfr(
              Number.parseFloat(`${a.my_grp}`),
              Number.parseFloat(`${b.my_grp}`)
            );
          default:
            return this.cfr(
              (a as any)[this.sortState.field] ?? "",
              (b as any)[this.sortState.field] ?? ""
            );
        }
      });
    }
  }

  protected scrollToLeft() {
    this.inner.scrollLeft = 0;
    this.checkPosition();
  }

  protected scrollToRight() {
    this.inner.scrollLeft = this.getTableWidth() - this.getElementWidth();
    this.checkPosition();
  }

  protected checkPosition() {
    this.position.overflow = this.getElementWidth() < this.getTableWidth();
    this.position.scrolledToRight =
      this.inner.scrollLeft == this.getTableWidth() - this.getElementWidth();
    this.position.scrolledToLeft = this.inner.scrollLeft == 0;
  }

  protected getElementWidth(): number {
    return this.inner?.clientWidth || 0;
  }

  protected getTableWidth(): number {
    return this.table?.clientWidth || 0;
  }

  protected onSelectedMultipleValue(selected: Array<string[]>) {
    if (selected[0] !== undefined) {
      this.selected = selected[0];
    }
  }
}
